import { render, staticRenderFns } from "./BeneficiaryHeader.vue?vue&type=template&id=256693ed"
import script from "./BeneficiaryHeader.vue?vue&type=script&lang=js"
export * from "./BeneficiaryHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports